(() => {
  const APP38_VARIANT_IDS = new Set(['56626093359429', '56936270430533']);
  const MINIMUM_QUANTITY = 4;

  const isApp38Variant = (value) => APP38_VARIANT_IDS.has(String(value || ''));

  const selectedVariantId = (form) => {
    const variantField = form.querySelector('[name="id"]');
    return variantField ? variantField.value : '';
  };

  const prepareProductForm = (form) => {
    const app38 = isApp38Variant(selectedVariantId(form));
    let quantity = form.querySelector('[name="quantity"]');
    const injectedQuantity = form.querySelector('[data-app38-injected-quantity]');

    if (!app38) {
      injectedQuantity?.remove();
      return;
    }

    if (!quantity) {
      quantity = document.createElement('input');
      quantity.type = 'hidden';
      quantity.name = 'quantity';
      quantity.dataset.app38InjectedQuantity = 'true';
      form.appendChild(quantity);
    }

    quantity.value = String(Math.max(Number(quantity.value) || 0, MINIMUM_QUANTITY));
    quantity.min = String(MINIMUM_QUANTITY);
    quantity.dataset.min = String(MINIMUM_QUANTITY);
  };

  const prepareCartInput = (input) => {
    if (!isApp38Variant(input.dataset.quantityVariantId)) return;

    input.dataset.min = String(MINIMUM_QUANTITY);
    const quantity = Number(input.value);
    if (quantity > 0 && quantity < MINIMUM_QUANTITY) {
      input.value = String(MINIMUM_QUANTITY);
    }
  };

  const preparePage = (root = document) => {
    root.querySelectorAll('form[action*="/cart/add"]').forEach(prepareProductForm);
    root.querySelectorAll('[data-quantity-variant-id]').forEach(prepareCartInput);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form instanceof HTMLFormElement && form.matches('form[action*="/cart/add"]')) {
      prepareProductForm(form);
    }
  }, true);

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;

    const productForm = target.closest('form[action*="/cart/add"]');
    if (productForm) prepareProductForm(productForm);

    if (target.matches('[data-quantity-variant-id]')) prepareCartInput(target);
  }, true);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        const form = mutation.target.closest?.('form[action*="/cart/add"]');
        if (form) prepareProductForm(form);
        continue;
      }

      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) preparePage(node);
      });
    }
  });

  const start = () => {
    preparePage();
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
